import { configureStore } from '@reduxjs/toolkit';

import authReducer from '@/features/auth/authSlice';
import clientsReducer from '@/features/clients/clientsSlice';
import errorReducer from '@/features/error/errorSlice';
import onboardingReducer from '@/features/onboarding/onboardingSlice';
import subscriptionReducer from '@/features/subscription/subscriptionSlice';
import taxPortalReducer from '@/features/taxPortal/taxPortalSlice';
import finkAssistantReducer from '@/features/finkAssistant/finkAssistantSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    clients: clientsReducer,
    error: errorReducer,
    onboarding: onboardingReducer,
    subscription: subscriptionReducer,
    taxPortal: taxPortalReducer,
    finkAssistant: finkAssistantReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
